import { BasicEntity, DomainSecurityLevel } from './Catalogs'
import { License } from './catalogs/Licenses'

export enum RoleNames {
  OPERATIONS_ADMIN = 'operationsAdmin',
  FINANCES_ADMIN = 'financesAdmin',
  FINANCES_CONTROL = 'financesControl',
  CLIENT_GENERIC_ADMIN = 'genericAdmin',
  CLIENT_OWNER = 'owner',
  SUPPORT = 'SOPORTE',
  PROJECTS = 'PROYECTOS',
  API_REPORTS = 'API-REPORTS',
  MOBILE = 'mobile'
}

export const ADMIN_ROLES: RoleNames[] = [
  RoleNames.OPERATIONS_ADMIN,
  RoleNames.FINANCES_CONTROL,
  RoleNames.FINANCES_ADMIN,
  RoleNames.SUPPORT,
  RoleNames.PROJECTS,
  RoleNames.API_REPORTS
]

export enum PermissionNames {
  CLIENTS_READ = 'clients:read',
  CLIENTS_UPDATE = 'clients:update',
  CLIENTS_CREATE = 'clients:create',
  CLIENTS_IMPORT = 'clients:import',
  WORKSPACES_READ = 'workspaces:read',
  WORKSPACES_UPDATE = 'workspaces:update',
  WORKSPACES_CREATE = 'workspaces:create',
  WORKSPACES_DELETE = 'workspaces:delete',
  WORKSPACES_IMPORT = 'workspaces:import',
  DOMAINS_READ = 'domains:read',
  DOMAINS_UPDATE = 'domains:update',
  DOMAINS_OPEN_CLOSE = 'domains:open_close',
  DOMAINS_CREATE = 'domains:create',
  DOMAINS_IMPORT = 'domains:import',
  PERMISSIONS_CREATE = 'permissions:create',
  PERMISSIONS_READ = 'permissions:read',
  PERMISSIONS_UPDATE = 'permissions:update',
  PERMISSIONS_DELETE = 'permissions:delete',
  ROLES_CREATE = 'roles:create',
  ROLES_READ = 'roles:read',
  ROLES_UPDATE = 'roles:update',
  ROLES_DELETE = 'roles:delete',
  USERS_READ = 'users:read',
  USERS_READ_DOMAIN = 'users:readDomain',
  USERS_UPDATE = 'users:update',
  USERS_CREATE = 'users:create',
  USERS_DELETE = 'users:delete',
  USERS_RESETPASSWORD = 'users:resetPassword',
  USERS_IMPORT = 'users:import',
  PROJECTS_CREATE = 'projects:create',
  PROJECTS_READ = 'projects:read',
  PROJECTS_UPDATE = 'projects:update',
  DEVICES_READ = 'devices:read',
  DEVICES_DELETE = 'devices:delete',
  GROUPS_CREATE = 'groups:create',
  GROUPS_READ = 'groups:read',
  GROUPS_UPDATE = 'groups:update',
  GROUPS_DELETE = 'groups:delete',
  GROUPS_IMPORT = 'groups:import',
  LICENSES_READ = 'licenses:read',
  LICENSES_DELETE = 'licenses:delete',
  CATALOGS_READ = 'catalogs:read',
  CATALOGS_CREATE = 'catalogs:create',
  CATALOGS_UPDATE = 'catalogs:update',
  CATALOGS_DELETE = 'catalogs:delete',
  CATALOGS_GROUPING= 'catalogs:grouping',
  FILLS_ASSIGNMENT = 'fills:assignment',
  FILLS_CREATE = 'fills:create',
  FILLS_DELETE = 'fills:delete',
  FILLS_EDIT = 'fills:edit',
  TYPIST_VIEW = 'typist:view',
  FILLS_INTEGRATE = 'fills:integrate',
  FILLS_INTEGRATE_WORKED = 'fills:integrateWorked',
  FILLS_MODIFY = 'fills:modify',
  FILLS_PDF = 'fills:pdf',
  FILLS_QUICKEDIT = 'fills:quickEdit',
  FILLS_READ = 'fills:read',
  FILLS_UPDATE = 'fills:update',
  FILLS_VIEW = 'fills:view',
  FILLSMETADATA_VIEW = 'fillMetadata:view',
  ATTACHMENTS_READ = 'attachments:read',
  ATTACHMENTS_CREATE = 'attachments:create',
  TEMPLATES_READ = 'templates:read',
  DATAFEED_CREATE = 'datafeed:create',
  DATAFEED_DELETE = 'datafeed:delete',
  DATAFEEDATTACH_CREATE = 'datafeedAttach:create',
  INTEGRATION_CREATE = 'integration:create',
  INTEGRATION_DELETE = 'integration:delete',
  INTEGRATION_UPDATE = 'integration:update',
  NORMALIZATION_CREATE = 'normalization:create',
  NORMALIZERS_READ = 'normalizers:read',
  TASKS_VIEW = 'tasks:view',
  TASKS_READ = 'tasks:read',
  TASKS_VERIFICATION = 'tasks:verification',
  COMPOSE_MESSAGE_VIEW = 'composeMessage:view'
}

export enum MapProvider {
  GOOGLE = 'GOOGLE',
  MAPBOX = 'MAPBOX'
}

export class UserClient {
  id: number
  name: string
}

export class UserDomain {
  id: number
  name: string
  firebaseUUID: string
  trackingMode: string
  securityLevel: DomainSecurityLevel = DomainSecurityLevel.LOW
  mapProvider: MapProvider
}

export class UserPermission {
  id: number
  name: PermissionNames
}

export class UserRole {
  id: number
  name: RoleNames
  copyFromRole: any
  permissions: UserPermission[]
}

export class UserInfo {
  id: number
  name: string
  firstName: string
  lastName: string
  email: string
  emailExtra: string
  cellPhone: {
    countryCode: string
    number: string
  }
  phoneExtra: string
  status: string
  billable: boolean
  extendedPermissions: boolean
  domain: UserDomain
  role: UserRole
  client: UserClient
  groups: BasicEntity[]
  license: License
  creationDate: Date
  updateDate: Date
}
